import { Component } from "@angular/core";
import {
  PageToolbarItemType,
  PageTooolbarItem
} from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item";
import { PageToolbarItemComponent } from "src/app/components/ui/page/page-shared/page-toolbar/page-toolbar-item.component";

@Component({
  selector: "snt-page-toolbar-divider",
  template: "",
  providers: [
    {
      provide: PageToolbarItemComponent,
      useExisting: PageToolbarDividerComponent
    }
  ],
  standalone: false
})
export class PageToolbarDividerComponent implements PageTooolbarItem {
  type: PageToolbarItemType = "divider";
}
